import React from 'react';
import SpotlightHeroItem from './item';
import { NewBrandsHeroData } from '@/shared/types/landing-page';
import './index.less';

interface IProps {
  data: NewBrandsHeroData;
  onBtnClick: () => void;
}

const SpotlightHero = ({ data, onBtnClick }: IProps) => {
  return (
    <div className="spotlight-hero" style={{ background: data.bgColor }}>
      <div className="max-content">
        <div className="header">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          {data.preTitleImg && <img className="pre-title-img" src={data.preTitleImg} alt={data.title} />}

          <div className="text-content">
            <span className="title" style={{ color: data.titleColor }}>
              {data.title}
            </span>
            <span className="subtitle" style={{ color: data.titleColor }}>
              {data.subtitle}
            </span>
          </div>
          <button className="hero-btn" onClick={onBtnClick}>
            {data.btnText}
          </button>
        </div>
        <SpotlightHeroItem
          spotlightItems={data.spotlightItems}
          textColor={data.titleColor}
          showItems={data.showHeroItem}
        />
      </div>
    </div>
  );
};

export default SpotlightHero;
